export default __webpack_public_path__ + "static/ADOT-cluster-a05df1c5e8a048cfef4e29d77fc14603.png";